import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);
  const toggleRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    setScrolled(false);
  }, [location]);

  useEffect(() => {
    if (!menuOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKey = (event) => {
      if (event.key === 'Escape') { setMenuOpen(false); toggleRef.current.focus(); }
      if (event.key === 'Tab') {
        const items = navRef.current.querySelectorAll('.mobile-menu-toggle, .nav-menu a');
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    const handleResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
    window.addEventListener('keydown', handleKey);
    window.addEventListener('resize', handleResize);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKey);
      window.removeEventListener('resize', handleResize);
    };
  }, [menuOpen]);

  return (
    <nav ref={navRef} aria-label="Main navigation" className={`navigation${scrolled ? ' scrolled' : ''}${menuOpen ? ' menu-open' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src="/logo-official.png" alt="Casa Primas" />
          <span className="nav-brand-text">Casa Primas</span>
        </Link>

        <button
          ref={toggleRef}
          className="mobile-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-controls="primary-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul onClick={(event) => { if (event.target.closest('a')) setMenuOpen(false); }} id="primary-menu" className={`nav-menu${menuOpen ? ' open' : ''}`}>
          <li><NavLink to="/" end>Projects</NavLink></li>
          <li><NavLink to="/meet-the-primas">Meet the Primas</NavLink></li>
          <li><NavLink to="/services">Services</NavLink></li>
          <li><a href="mailto:hello@casaprimas.com">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
